import { ReactNode } from "react";
import {
  AirplaneIcon,
  DiscountsIcon,
  GiftcardsIcon,
  PointsExchangeIcon,
  TransactionIcon,
  HotelsIcon,
  TopupMenuIcon,
} from "src/assets/Icons";
import { MdLogout } from "react-icons/md";

type MenuKeysType = "GiftCards" | "Discounts" | "Loyalty" | "Travel" | "Hotel" | "History" | "TopUp";

export type SubMenuItem = {
  key: string;
  label: string;
  icon: ReactNode;
  route: string;
  order: number;
  type: MenuKeysType;
  isstatic: boolean;
  underMenu?: "Main" | "User" | "Action";
  hideWhenIntegrated?: boolean;
};

const MENU_MODULES = [
  {
    type: "GiftCards",
    icon: <GiftcardsIcon strokeWidth={0.2} className="h-full w-full" />,
    label: "Menu.giftcards",
    route: "giftcards",
    order: 4,
    isstatic: false,
    underMenu: "Main",
  },
  {
    type: "Discounts",
    label: "Menu.discounts",
    icon: <DiscountsIcon strokeWidth={0.2} className="h-full w-full" />,
    order: 3,
    route: "discounts",
    isstatic: false,
    underMenu: "Main",
  },
  {
    type: "Loyalty",
    route: "points",
    label: "Menu.points",
    icon: <PointsExchangeIcon strokeWidth={1} className="h-full w-full" />,
    order: 2,
    isstatic: false,
    underMenu: "Main",
  },
  {
    type: "Travel",
    route: "travel",
    label: "Menu.flights",
    icon: <AirplaneIcon strokeWidth={1} transform="rotate(-45 0 0) scale(1.2,1.2)" className="h-full w-full" />,
    order: 0,
    isStatic: false,
    underMenu: "Main",
  },
  {
    type: "Hotel",
    route: "hotel",
    label: "Menu.hotels",
    order: 1,
    icon: <HotelsIcon className="h-full w-full" />,
    isstatic: false,
    underMenu: "Main",
  },
  {
    key: "transactions",
    label: "Menu.transactions",
    icon: <TransactionIcon />,
    route: "history",
    type: "History",
    order: 10,
    isstatic: true,
    underMenu: "User",
  },
  {
    key: "signout",
    label: "Menu.signout",
    icon: <MdLogout className="h-full w-full" />,
    route: "signout",
    type: "History",
    order: 99,
    isstatic: true,
    underMenu: "Action",
    hideWhenIntegrated: true,
  },
  {
    key: "TopUp",
    label: "Menu.payments",
    icon: <TopupMenuIcon className="h-full w-full" />,
    route: "topup",
    type: "TopUp",
    order: 99,
    isstatic: false,
    underMenu: "Main",
    hideWhenIntegrated: false,
  },
] as const as SubMenuItem[];

type MenuRoutesType = (typeof MENU_MODULES)[number]["route"];

const MENU_KEY_ROUTES: Record<MenuKeysType, MenuRoutesType> = {
  GiftCards: "giftcards",
  Discounts: "discounts",
  Travel: "travel",
  Loyalty: "points",
  Hotel: "hotel",
  History: "history",
  TopUp: "topup",
};

export type { MenuKeysType, MenuRoutesType };
export { MENU_MODULES, MENU_KEY_ROUTES };
